module.exports = __webpack_public_path__ + "static/allcare-color-min-e8550191cefa672f9d2257c87d97233f.png";